<template>
  <FormGroup
      :scope="scope"
      :starts-enabled="true"
      :optional="false"
      :hide-label="true"
      :disable-margin="disableMargin"
      :disable-changed="disableChanged || null"
  >
    <template #default="{ inputName, inputId, label, error }">
      <div class="form-check" :class="{ 'mb-0': disableMargin, 'input-changed': wasChanged && !disableChanged }">
        <input type="hidden" value="off" :name="inputName">
        <input
            v-model="currentValue"
            :id="inputId" type="checkbox"
            value="on"
            class="form-check-input me-2"
            :class="{
              'is-invalid': error,
            }"
            :name="inputName"
        >
        <label :for="inputId" class="form-check-label">{{ label }}</label>
      </div>
    </template>
  </FormGroup>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "@/types";
import FormGroup from "@/components/backend/candidacy/form_builder/form_items/shared/FormGroup.vue";

export default defineComponent({
  name: "CheckBoxField",
  components: { FormGroup },
  props: {
    initialValue: {
      type: Boolean,
      required: true
    },
    scope: {
      type: Array as PropType<string[]>,
      required: true,
    },
    disableMargin: {
      type: Boolean,
      default: false,
    },
    disableChanged: {
      type: Boolean,
      default: false,
    },
  },
  data: ({ initialValue }) => ({ currentValue: initialValue }),
  computed: {
    wasChanged() {
      return this.initialValue !== this.currentValue;
    }
  },
  emits: ["update"],
  watch: {
    currentValue() {
      this.$emit('update', this.currentValue);
    }
  }
});
</script>
